import React from "react";
import PropTypes from "prop-types";
import { format } from "date-fns";
import "./index.scss";

const BookingDatesCell = ({ row }) => {
  const formatStartDate = row.original.start_date
    ? format(new Date(row.original.start_date), "dd MMM")
    : "";
  const formatEndDate = row.original.end_date
    ? format(new Date(row.original.end_date), "dd MMM yyyy")
    : "";
  return (
    <div data-testid="booking-dates-cell" className="booking-dates-cell">
      <div className="details">
        <span className="name">
          {formatStartDate} to {formatEndDate}
        </span>
      </div>
    </div>
  );
};

BookingDatesCell.propTypes = {
  row: PropTypes.oneOfType([PropTypes.object, PropTypes.func]).isRequired,
};

export default BookingDatesCell;
